import React, { useEffect } from 'react';

import { useFormik } from 'formik-next';
import moment from 'moment';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { theme } from '@waglabs/base-theme';
import { Typography } from '@waglabs/typography';

import { Container } from '../../../../../../components/Container';
import { DirectBookWalkerChip } from '../../../../../../components/DirectBookWalkerChip';
import {
  NAME_ENTER_PET_INFO,
  NAME_PET_INFO_ENTERED,
} from '../../../../../../components/Tracker/Segment/events';
import {
  DateFormat,
  PetStrings,
  Routes,
} from '../../../../../../constants';
import {
  useGetUrlQuery,
  useSegmentTrack,
} from '../../../../../../hooks';
import { useGetWalkerFromUrlQuery } from '../../../../../../hooks/useGetWalkerFromUrlQuery';
import { petsSlice } from '../../../../../../slices/pets';
import { webApp } from '../../../../../../types/webapp';
import { isInitialValid } from '../../../../../../utils';

import {
  PetInfoPart1Form,
  FormFields,
  schema,
} from './components/PetInfoPart1Form';

export const PetInfoPart1 = () => {
  const {
    push,
  } = useHistory();
  const queryParams = useGetUrlQuery();
  const walker = useGetWalkerFromUrlQuery();

  const dispatch = useDispatch();

  const {
    execute: segmentTrack,
  } = useSegmentTrack();

  useEffect(() => {
    segmentTrack({
      event: NAME_ENTER_PET_INFO,
    });
  }, []);

  const formik = useFormik({
    initialValues: schema.cast(undefined),
    isInitialValid,
    validationSchema: schema,
    onSubmit: (values) => {
      const name = values[FormFields.PetName];
      const breed = values[FormFields.PetBreed].value;
      const rawBirthday = values[FormFields.PetBirthdate];

      const pet: webApp.V6.Pet = {
        breed,
        gender: PetStrings.Gender.Unspecified,
        name,
        size: PetStrings.Size.Unspecified,
        sterile: PetStrings.Sterile.Unspecified,
        type: PetStrings.TypeNames.Dog,
        uuid: uuidv4(),
        birthday: moment(rawBirthday).format(DateFormat.Birthday),
        imageUrl: values[FormFields.PetImageUrl],
      };

      dispatch(petsSlice.actions.add(pet));

      segmentTrack({
        event: NAME_PET_INFO_ENTERED,
        data: {
          pet_names: [name],
          pet_breeds: [breed],
          pet_birthdays: [moment(rawBirthday).format(DateFormat.Birthday)],
        },
      });

      const nextUrl = queryString.stringifyUrl({
        url: Routes.SignupPetInfoPart2,
        query: {
          ...queryParams,
          petId: pet.uuid,
        },
      });

      push(nextUrl);
    },
  });

  const walkerName = walker?.name;
  const title = walkerName
    ? `Tell ${walkerName} about your furry friend`
    : 'Okay! Before we find your perfect Pet Caregiver...';

  return (
    <Container>
      {walker.isValid && (
        <DirectBookWalkerChip
          value={walker}
          my="16px"
        />
      )}

      <Typography
        fontFamily="muliBold"
        fontSize="22px"
        color={theme.colors.charcoal}
      >
        {title}
      </Typography>
      <Typography
        color={theme.colors.dimGray}
      >
        Let&apos;s start with your pet&apos;s basic info
      </Typography>
      <PetInfoPart1Form
        formik={formik}
      />
    </Container>
  );
};
